import './instrument';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App.tsx';
import './index.css';

if (import.meta.env.DEV) {
  console.info('[Sentry] Disabled in development mode');
}

createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary fallback={
    <div className="flex flex-col items-center justify-center min-h-screen gap-3 text-center p-6">
      <p className="text-lg font-medium text-gray-900">Something went wrong</p>
      <p className="text-sm text-gray-500">Please refresh the page to continue.</p>
      <button
        onClick={() => window.location.reload()}
        className="mt-2 px-4 py-2 text-sm font-medium rounded-md bg-gray-900 text-white hover:bg-gray-700"
      >
        Refresh
      </button>
    </div>
  }>
    <App />
  </Sentry.ErrorBoundary>
);
